import strFunc from "@/lib/lyg/string";
import RadioListArea from '@/pcomponents/common/crud/write/radio/radio_arr';

function DefaultContentArea(props: any) {
  let myProps = {
    default_todo_content: {},
    set_default_todo_content: (inData: any) => { },
    select_subject_option_arr: [],
    add_custom_todo: () => { },
    ...props
  };
  let default_todo_content = myProps.default_todo_content;
  let select_subject_option_arr = myProps.select_subject_option_arr;
  select_subject_option_arr = [
    { "value": "수학", "text": "수학" },
    { "value": "영어", "text": "영어" },
    { "value": "교과맵핑", "text": "교과맵핑" },
  ];
  const onChangeInput = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let change_default_todo_content = { ...myProps.default_todo_content };
    change_default_todo_content[name] = value;
    myProps.set_default_todo_content(change_default_todo_content);
    strFunc.set_storage("make_todo_default_todo_content", JSON.stringify(change_default_todo_content));
  };

  return (
    <span>
      <span style={{ "display": "inline-block", padding: "0px 5px", border: "1px solid #ddd", borderRadius: "5px" }}>
        <table>
          <tbody>
            <tr>
              <th>구분</th>
              <td style={{ paddingLeft: "5px" }}>
                <RadioListArea
                  name="a_sort"
                  value={default_todo_content["a_sort"]}
                  handleInputChange={onChangeInput}
                  valueTextArr={[
                    { "value": "homework", "text": "숙제" },
                    { "value": "study", "text": "학습" }
                  ]}
                ></RadioListArea>
              </td>
            </tr>
          </tbody>
        </table>
      </span>
      <span className="ml-2" style={{ "display": "inline-block", padding: "0px 5px", border: "1px solid #ddd", borderRadius: "5px" }}>
        <table>
          <tbody>
            <tr>
              <th>과목</th>
              <td style={{ paddingLeft: "5px" }}>
                <RadioListArea
                  name="a_subject" value={default_todo_content["a_subject"]}
                  handleInputChange={onChangeInput}
                  valueTextArr={select_subject_option_arr}
                ></RadioListArea>
              </td>
            </tr>
          </tbody>
        </table>
      </span>
    </span>
  );
};
export default DefaultContentArea;